import React, { useState } from "react";
import { Pencil, Trash2 } from "lucide-react";

export default function UsuariosTabela({ usuarios, recarregar, onEditar }) {
  const [usuarioSelecionado, setUsuarioSelecionado] = useState(null);

  const excluirUsuario = async (id) => {
    if (window.confirm("Tem certeza que deseja excluir este usuário?")) {
      try {
        const API_URL = process.env.REACT_APP_API_URL;
        const response = await fetch(`${API_URL}/usuarios.php`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
          body: JSON.stringify({ acao: "excluir", id }),
        });

        if (response.ok) {
          alert("Usuário excluído com sucesso!");
          recarregar();
        } else {
          alert("Erro ao excluir usuário.");
        }
      } catch (error) {
        console.error("Erro ao excluir usuário:", error);
        alert("Erro ao excluir usuário. Verifique o console.");
      }
    }
  };

  const handleRowClick = (usuario) => {
    setUsuarioSelecionado(usuario.id);
  };

  return (
    <div className="w-full">
      <div className="bg-white border border-gray-300 shadow-sm">
        <div className="max-h-[400px] overflow-y-auto">
          <table className="w-full text-sm">
            <thead className="sticky top-0 z-10" style={{ backgroundColor: '#303357' }}>
              <tr>
                <th className="py-3 px-4 text-left text-white font-medium text-xs uppercase tracking-wider border-r border-gray-400">
                  # CÓDIGO
                </th>
                <th className="py-3 px-4 text-left text-white font-medium text-xs uppercase tracking-wider border-r border-gray-400">
                  👤 NOME
                </th>
                <th className="py-3 px-4 text-left text-white font-medium text-xs uppercase tracking-wider border-r border-gray-400">
                  💼 FUNÇÃO
                </th>
                <th className="py-3 px-4 text-center text-white font-medium text-xs uppercase tracking-wider">
                  ⚙️ AÇÕES
                </th>
              </tr>
            </thead>
            <tbody className="bg-white">
              {usuarios.map((usuario, index) => (
                <tr
                  key={usuario.id}
                  onClick={() => handleRowClick(usuario)}
                  className={`cursor-pointer transition-colors duration-150 ${
                    usuario.id === usuarioSelecionado
                      ? "bg-blue-50 border-l-4 border-l-blue-500"
                      : index % 2 === 0 
                        ? "bg-white hover:bg-gray-50" 
                        : "bg-gray-50 hover:bg-gray-100"
                  }`}
                >
                  <td className="py-3 px-4 text-gray-700 font-medium border-r border-gray-400 border-b border-gray-400">
                    {usuario.codigo}
                  </td>
                  <td className="py-3 px-4 text-gray-800 border-r border-gray-400 border-b border-gray-400">
                    <div className="flex items-center">
                      <div className="w-2 h-2 bg-orange-500 rounded-full mr-3"></div>
                      {usuario.nome}
                    </div>
                  </td>
                  <td className="py-3 px-4 text-gray-700 border-r border-gray-400 border-b border-gray-400">
                    {usuario.funcao}
                  </td>
                  <td className="py-3 px-4 text-center border-b border-gray-400">
                    <div className="flex justify-center gap-2">
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          onEditar(usuario);
                        }}
                        className="bg-gray-600 hover:bg-gray-700 text-white p-2 rounded-md transition-colors duration-200 shadow-sm"
                        title="Editar usuário"
                        aria-label="Editar usuário"
                      >
                        <Pencil size={14} />
                      </button>
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          excluirUsuario(usuario.id);
                        }}
                        className="bg-red-500 hover:bg-red-600 text-white p-2 rounded-md transition-colors duration-200 shadow-sm"
                        title="Excluir usuário"
                        aria-label="Excluir usuário"
                      >
                        <Trash2 size={14} />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
              {usuarios.length === 0 && (
                <tr>
                  <td colSpan="4" className="text-center py-8 text-gray-500 border-b border-gray-400">
                    <div className="flex flex-col items-center">
                      <div className="text-4xl mb-2">📋</div>
                      <p className="text-lg font-medium">Nenhum usuário encontrado</p>
                      <p className="text-sm text-gray-400">Adicione usuários para começar</p>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}